module.exports = __webpack_public_path__ + "static/media/salao_jardim_7.f4b34265.jpg";